import Vue from 'vue'
import App from './App'

import router from './router'
import store from './store/store'
import VueLocalStorage from 'vue-localstorage'
import Notifications from 'vue-notification'
import VueChatScroll from 'vue-chat-scroll'
import vueShapeImg from 'vueshapeimg'
import JsonExcel from 'vue-json-excel'
import JsonCSV from 'vue-json-csv'
import vuescroll from 'vuescroll'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)


Vue.use(vuescroll);

import VueFeather from 'vue-feather';
Vue.use(VueFeather);
 
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueChatScroll)
Vue.use(vueShapeImg)
Vue.config.productionTip = false
Vue.use(Notifications);
Vue.use(VueLocalStorage)
Vue.component('downloadCsv', JsonCSV)
Vue.use(require('vue-moment'))

//=================import plugin=============================
import { prismMixins } from './plugins/prism_admin/index.ts';
Vue.mixin(prismMixins);

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js